import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchDashboardStats, fetchInspections } from "../Reducers/actions";

const ZwembadinspectiesDashboard = () => {
  const dispatch = useDispatch();
  const { dashboardStats, inspections } = useSelector(state => state.zwembadinspecties);

  useEffect(() => {
    dispatch(fetchDashboardStats());
    dispatch(fetchInspections({ status: 'in_progress' }));
  }, [dispatch]);

  const stats = dashboardStats || {};

  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-12">
          <h2>Zwembadinspecties Dashboard</h2>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-2">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <h6 className="card-title">Totaal</h6>
              <h3>{stats.total || 0}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-secondary text-white">
            <div className="card-body">
              <h6 className="card-title">Concept</h6>
              <h3>{stats.draft || 0}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <h6 className="card-title">In uitvoering</h6>
              <h3>{stats.in_progress || 0}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-success text-white">
            <div className="card-body">
              <h6 className="card-title">Voltooid</h6>
              <h3>{stats.completed || 0}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-info text-white">
            <div className="card-body">
              <h6 className="card-title">Goedgekeurd</h6>
              <h3>{stats.approved || 0}</h3>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <h6 className="card-title">Afgekeurd</h6>
              <h3>{stats.rejected || 0}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="row mb-4">
        <div className="col-md-3">
          <Link to="/zwembadinspecties/inspecties/nieuw" className="btn btn-primary btn-lg btn-block">
            <i className="fas fa-plus-circle"></i><br />
            Nieuwe Inspectie
          </Link>
        </div>
        <div className="col-md-3">
          <Link to="/zwembadinspecties/zwembaden" className="btn btn-info btn-lg btn-block">
            <i className="fas fa-swimming-pool"></i><br />
            Zwembaden Beheren
          </Link>
        </div>
        <div className="col-md-3">
          <Link to="/zwembadinspecties/templates" className="btn btn-success btn-lg btn-block">
            <i className="fas fa-list-check"></i><br />
            Sjablonen Beheren
          </Link>
        </div>
        <div className="col-md-3">
          <Link to="/zwembadinspecties/inspecties" className="btn btn-warning btn-lg btn-block">
            <i className="fas fa-clipboard-list"></i><br />
            Alle Inspecties
          </Link>
        </div>
      </div>

      {/* Active Inspections */}
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4>Lopende Inspecties</h4>
            </div>
            <div className="card-body">
              {inspections.length === 0 ? (
                <p className="text-center text-muted">Geen lopende inspecties</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Titel</th>
                        <th>Locatie</th>
                        <th>Sjabloon</th>
                        <th>Inspecteur</th>
                        <th>Datum</th>
                        <th>Actie</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inspections.map((inspection) => (
                        <tr key={inspection._id}>
                          <td>
                            <strong>{inspection.title || '-'}</strong>
                          </td>
                          <td>{inspection.company_id?.name || '-'}</td>
                          <td>{inspection.template_id?.name || '-'}</td>
                          <td>
                            {inspection.inspector_id?.voornaam} {inspection.inspector_id?.achternaam}
                          </td>
                          <td>
                            {new Date(inspection.inspection_date).toLocaleDateString('nl-NL')}
                          </td>
                          <td>
                            <Link
                              to={`/zwembadinspecties/inspecties/${inspection._id}/uitvoeren`}
                              className="btn btn-sm btn-primary"
                            >
                              Ga verder <i className="fas fa-arrow-right"></i>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZwembadinspectiesDashboard;
